import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const WebChannelsPage: React.FC = () => {
  const channels = analyticsSnapshot.webAnalytics.channels;
  const latestOrganic = findLatestValue(channels.datasets[0].data);
  const latestPaid = findLatestValue(channels.datasets[1].data);
  const label = latestOrganic.index >= 0 ? channels.labels[latestOrganic.index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.webAnalytics.channels.insights;

  const chartData = useMemo<ChartData<'line'>>(
    () => ({
      labels: Array.from(channels.labels),
      datasets: [
        {
          label: 'Organik Trafik',
          data: Array.from(channels.datasets[0].data)
        },
        {
          label: 'Ücretli Trafik',
          data: Array.from(channels.datasets[1].data)
        }
      ]
    }),
    [channels.labels, channels.datasets]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Kanal Performansı</h1>
          <p className="text-white/70 mt-2">
            Organik ve ücretli kanalların trafik katkısını karşılaştırarak kanal yatırımlarını yönetin.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{label}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricSummary
          title="Organik Trafik"
          value={latestOrganic.value}
          description="Organik kanallarla gelen ziyaretler."
        />
        <MetricSummary
          title="Ücretli Trafik"
          value={latestPaid.value}
          description="Ücretli kampanyalarla gelen ziyaretler."
        />
      </div>

      <ChartCard
        title="Aylık Kanal Trafiği"
        description="Organik ve ücretli kanalların performans trendleri."
        chartType="line"
        data={chartData}
        insights={insights}
      />

    </div>
  );
};

export default WebChannelsPage;

